define("shared/components/shared/wizard/cancel-button", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @onCancel}}
    <Shared::Ui::Button
      @onClick={{action "cancelWizard"}}
      @text={{this.buttonText}}
      @variant="none"
      class={{if @buttonClass @buttonClass this.defaultClass}}
    />
  {{/if}}
  */
  {
    "id": "6TyoDnX0",
    "block": "[[[41,[30,1],[[[1,\"  \"],[8,[39,1],[[16,0,[52,[30,2],[30,2],[30,0,[\"defaultClass\"]]]]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,2],[[30,0],\"cancelWizard\"],null],[30,0,[\"buttonText\"]],\"none\"]],null],[1,\"\\n\"]],[]],null]],[\"@onCancel\",\"@buttonClass\"],false,[\"if\",\"shared/ui/button\",\"action\"]]",
    "moduleName": "shared/components/shared/wizard/cancel-button.hbs",
    "isStrictMode": false
  });
  let CancelButtonComponent = _exports.default = (_class = class CancelButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _defineProperty(this, "defaultClass", 'o--btn o--btn--outline u--p__lr__lg u--float--left qa--slide_cancel');
    }
    get defaultButtonText() {
      return this.intl.t('shared_words.cancel');
    }
    get buttonText() {
      return this.args.text ? this.args.text : this.defaultButtonText;
    }
    cancelWizard() {
      if (this.args.onCancel) {
        this.args.onCancel();
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "cancelWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelWizard"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CancelButtonComponent);
});